import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { Trans } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useAtomValue } from 'jotai';
import { locationStateAtom } from '../../../../history';
import { isOrder } from '../../../Sections/order/utils';
import { ReturnButtonContainer } from './components';

export const ReturnButton = () => {
  const locationOrder = useAtomValue(locationStateAtom);
  if (isOrder(locationOrder) === false) {
    return null;
  }
  if (locationOrder.previous === '') {
    return null;
  }
  return (
    <ReturnButtonContainer>
      <ouiDom.A.AButton
        to={locationOrder.previous}
        backgroundColor={ouiStyle.Constants.Colors.primary}
        hoverBackgroundColor={ouiStyle.Constants.Colors.primaryDarker}
        borderColor={ouiStyle.Constants.Colors.primary}
        color={ouiStyle.Constants.Colors.inverted}
        lineFactor={1.25}
        widthLines={7.5}
      >
        <Trans>
          Retour
        </Trans>
      </ouiDom.A.AButton>
    </ReturnButtonContainer>
  );
};
